"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeFormats = void 0;
exports.TimeFormats = {
    dateTimeWithOffset: "YYYY-MM-DD[T]HH:mm:ssZ",
    dateTimeUTC: "YYYYMMDD[T]HHmmss[Z]",
    allDay: "YYYYMMDD",
};
//# sourceMappingURL=utils.js.map